import { CATEGORY_IDS } from './categoryIds';

export const CATEGORY_IDS_TO_HIDE_ADD_EXISTING_BUTTON = [
  CATEGORY_IDS.partnerProvidedNonRecurringItems.id,
  CATEGORY_IDS.otherNrcPromotionsAndDiscounts.id,
  CATEGORY_IDS.demoKit.id,
];
